export default "__VITE_ASSET__CoZhXh0X__"